module.exports = __webpack_public_path__ + "static/250429_12M_2024_Investor_call_Dial_in_information-28910736a684f8f30dff2a6db3c0681b.pdf";